var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77344 1.1875H9.5V12.4316H0.5V1.1875H1.23828V0.431641H1.98828V1.1875H3.5V0.431641H4.25V1.1875H5.76172V0.431641H6.51172V1.1875H8.02344V0.431641H8.77344V1.1875ZM8.75 11.6816V1.9375H1.25V11.6816H8.75ZM7.25 3.4375V4.1875H2.75V3.4375H7.25ZM2.75 10.1934V9.44336H7.25V10.1934H2.75ZM2.75 7.1875V6.4375H7.25V7.1875H2.75Z",
    fill: "#323130"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notesIcon.d7ba8f7699370a0757e2311d696a89fb.svg";
export { ForwardRef as ReactComponent };